module.exports = __webpack_public_path__ + "img/40_00_070_145.be4fe3a3.jpg";